import { useState } from 'react';

import CloseIcon from "@mui/icons-material/Close";
import { DateTimeInput } from '../formComponents/DateTimeInput';
import { TimeDevice } from '../formComponents/TimeDevice';


export function EditForm({ isOpen,
  onClose,
  employeePersonalInformationId,
  setEmployeePersonalInformationId,
  employeePersonalInformationFullName,
  setEmployeePersonalInformationFullName,
  timeIn,
  setTimeIn,
  deviceNameTimeIn,
  setDeviceNameTimeIn,
  timeOut,
  setTimeOut,
  deviceNameTimeOut,
  setDeviceNameTimeOut,
  reasonForTampering,
  setReasonForTampering,
  handleUpdate }) {
  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (!employeePersonalInformationId
      || !timeIn
      // || !deviceNameTimeIn
      || !timeOut
      // || !deviceNameTimeOut
      || !reasonForTampering
    ) {
      setErrorState(true);
      return;
    }
    handleUpdate(e);
    setErrorState(false);
    handleClose();
  };

  const handleClose = () => {
    onClose();
    setEmployeePersonalInformationId("");
    setEmployeePersonalInformationFullName("");
    setTimeIn("");
    setDeviceNameTimeIn("");
    setTimeOut("");
    setDeviceNameTimeOut("");
    setReasonForTampering("");
    setErrorState(false);
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Update Time Entry</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <div className="info-item-holder employee-select row" style={{ flexDirection: "row", justifyContent: "normal" }}>
                    <input
                      readOnly
                      className='employeeInput-select'
                      placeholder="Employee"
                      style={{ cursor: "not-allowed" }}
                      value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                    />
                  </div>
                  <span style={{
                    visibility: "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Time In</div>
                <div className="info-item-input">
                  <DateTimeInput date={timeIn} setDate={setTimeIn} />
                </div>
                <span style={{
                  visibility: !timeIn && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Time In Device</div>
                <div className="info-item-input">
                  <TimeDevice device={deviceNameTimeIn} setDevice={setDeviceNameTimeIn} />
                </div>
                <span style={{
                  visibility: "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Time Out</div>
                <div className="info-item-input">
                  <DateTimeInput date={timeOut} setDate={setTimeOut} />
                </div>
                <span style={{
                  visibility: !timeOut && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Time Out Device</div>
                <div className="info-item-input">
                  <TimeDevice device={deviceNameTimeOut} setDevice={setDeviceNameTimeOut} />
                </div>
                <span style={{
                  visibility: "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason For Tampering</div>
                <div className="info-item-input">
                  <textarea id="tamper" className="filterSelect"
                    style={{ width: "100%", minHeight: "50px", borderRadius: "3px", border: "1px solid #80808080", color: "rgb(104, 104, 104)" }}
                    value={reasonForTampering}
                    onChange={(e) => setReasonForTampering(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: !reasonForTampering && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "end", padding: "20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={(e) => submit(e)}>
                UPDATE
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}